import { ChevronLeftIcon } from '@chakra-ui/icons'
import {
  Box,
  Text,
  Button,
  Flex,
  Center,
  HStack,
  Spacer,
} from '@chakra-ui/react'
import { FunctionComponent, useContext } from 'react'
import { BsGear } from 'react-icons/bs'
import { PageEnum } from '.'
import { AppContext } from '../../libs/context'

interface IProps {
  id?: string
  onClose?: () => void
  tools?: string[]
  setPage?: React.Dispatch<React.SetStateAction<PageEnum>>
}

const SelectedModel: FunctionComponent<IProps> = ({
  id,
  onClose,
  tools,
  setPage,
}) => {
  const { model } = useContext(AppContext)

  return (
    <Flex bg="#F2F4F6" padding="0 15px" {...(id && { id })}>
      {onClose && (
        <Center>
          <Button onClick={onClose} borderRadius="0" fontSize="xl">
            <ChevronLeftIcon />
          </Button>
        </Center>
      )}
      <Box padding="15px" flex="auto">
        <HStack>
          <Box>
            {model && <Text fontSize="lg">{model.current.title}</Text>}
            <Text>Dimensions: 48 x 56 x 32</Text>
          </Box>
          <Spacer />
          {tools && tools.length > 0 && setPage && (
            <Box>
              <Button
                variant="brand"
                onClick={() => {
                  setPage(PageEnum.ProductConfiguration)
                }}
              >
                <BsGear></BsGear>
              </Button>
            </Box>
          )}
        </HStack>
      </Box>
    </Flex>
  )
}
export default SelectedModel
